<template src="./index.html"></template>

<script>
export default {
    name: 'LostPage',
}
</script>

<style lang="scss" src="./index.scss" scoped></style>